export default "__VITE_ASSET__Cgx7aPVm__"